import core from '@/helpers/client'

const requestService = {
  async headRequestDocumentAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments`,
      params
    )
    return result
  },
  async getRequestDocumentListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments`,
      params
    )
    return result
  },
  async getRequestDocumentDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}`
    )
    return result
  },
  async getRequestDocumentDetailByRefIdAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/ref_id/${id}`
    )
    return result
  },
  async getRequestDocumentTypeAsync() {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/requesttype`
    )
    return result
  },
  async CheckRequestApproveAllAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/check_process`
    )
    return result
  },
  async getHistoryDocumentByRIAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/histories`
    )
    return result
  },
  async validateProductRegisterOFMStockAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/bulk/validate/OFMStock`,
      model,null,false
    )
    return result
  },
  async validateProductRegisterDropShipAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/bulk/validate/DropShip`,
      model,null,false
    )
    return result
  },
  // async getRequestDataPayloadRemarkAsync(id, data_id) {
  //   const result = await core.fetch(
  //     `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/datas/${data_id}/remark`
  //   );
  //   return result;
  // },
  // async getRequestDataPayloadLastVersionAsync(id, data_id, rule_id) {
  //   const result = await core.fetch(
  //     `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/datas/${data_id}/${rule_id}/2lastversion`
  //   );
  //   return result;
  // },
  // async createRequestDocumentAsync(model) {
  //   const result = await core.create(
  //     `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments`,
  //     model
  //   );
  //   return result;
  // },
  // async updateRequestApproveStatusAsync(id, model) {
  //   const result = await core.update(
  //     `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/Status`,
  //     model
  //   );
  //   return result;
  // },
  // async approveRequestStatusWithDataAsync(id, data_id, rule_id, model) {
  //   const result = await core.update(
  //     `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/Status/Approve/Datas/${data_id}/${rule_id}`,
  //     model
  //   );
  //   return result;
  // },
  // async updateRequestDataPayloadAsync(id, data_id, rule_id, model) {
  //   const result = await core.update(
  //     `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/datas/${data_id}/${rule_id}`,
  //     model
  //   );
  //   return result;
  // },
  // async deleteRequestUserByIdAsync(id, openId) {
  //   const result = await core.delete(
  //     `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/RequestDocuments/${id}/users/${openId}`,
  //   );
  //   return result;
  // },
}
export default requestService
